export const iconFontAwesomeSpinnersRotateRight = (
	<i className="fa-solid fa-rotate-right"></i>
);
